import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { work } from '../../utility/work'

function Work() {

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <div className="section-work padding-tb-100">
            <img src="assets/img/work/work-shape-1.png" alt="work-shape-1" className="work-shape-1" />
            <img src="assets/img/work/work-shape-2.png" alt="work-shape-2" className="work-shape-2" />
            <img src="assets/img/work/work-shape-3.png" alt="work-shape-3" className="work-shape-3" />
            <div className="container">
                <div className="row">
                    <Fade triggerOnce duration={1000} direction='up' className="col-lg-6 col-sm-12">
                        <img src="assets/img/work/work.png" alt="work" className="work-image" />
                    </Fade>
                    <Fade triggerOnce duration={1500} direction='up' className="col-lg-6 col-sm-12">
                        <div className="zx-work">
                            <div className="zx-app-banner w-100">
                                <h4>Best Performance</h4>
                                <h2>How does AI app work.</h2>
                            </div>
                            <div className="container-fulid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="zx-app-work">
                                            {
                                                work.map((data, index) => (
                                                    <div key={index} className="zx-app-profile">
                                                        <div className="profile-image">
                                                            <img src={data.image} alt="cloud-computing" />
                                                        </div>
                                                        <div className="zx-detail">
                                                            <h5>{data.title}</h5>
                                                            <p>
                                                                {data.discription}
                                                            </p>
                                                            <div className="active-read">
                                                                <a onClick={handleSubmit} href="/">Read more</a>
                                                                <i className="fa-solid fa-arrow-right-long"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    )
}

export default Work
